import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Parametric from "@/pages/Parametric";
import OriginRisk from "@/pages/OriginRisk";
import Intelligence from "@/pages/Intelligence";
import AdaptationIntelligence from "@/pages/AdaptationIntelligence";
import FoodSupply from "@/pages/FoodSupply";
import NatureAsset from "@/pages/NatureAsset";
import WorkWith from "@/pages/WorkWith";
import Enter from "@/pages/Enter";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/parametric" element={<Parametric />} />
        <Route path="/origin-risk" element={<OriginRisk />} />
        <Route path="/intelligence" element={<Intelligence />} />
        <Route path="/adaptation-intelligence" element={<AdaptationIntelligence />} />
        <Route path="/food-supply" element={<FoodSupply />} />
        <Route path="/nature-asset" element={<NatureAsset />} />
        <Route path="/work-with" element={<WorkWith />} />
        <Route path="/enter/:door" element={<Enter />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
